import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { RegisterService } from '../../../api/register/register.service';
import { BloguserService } from 'api/bloguser/bloguser.service';
import { totalmem } from 'os';
import { BlogPostdetailsService } from 'api/blogpostdetails/blogpostdetails.service';
import { BlogpostService } from 'api/blogpost/blogpost.service';
import { Title } from '@angular/platform-browser';
import { ApiConstant } from 'api/api.constant';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'application-page',
    templateUrl: './blogverify.html',
})
export class Blogverify implements OnInit {
    blogpreview = []
    url: any
    id: number
    index: number
    blogversionid: number
    title: any
    version: any
    blog = []
    blogg = []
    isactive: boolean
    bid: number
    constructor(private router: Router,
        private blogpostdetailservice: BlogPostdetailsService,
        private blogpostService: BlogpostService, private titleService: Title, private apiconstant: ApiConstant) {
    }
    ngOnInit() {
        this.titleService.setTitle("Blog Verify  | Phoenix Games");
        this.url = this.apiconstant.blogurl
        this.initdata()
    }
    initdata() {
        this.blogpostService.allBpost().then(data => {
            if (data.status) {
                this.blogpreview = data.data
            }
        })
    }
    Preview(url, version, id) {
        var id2 = btoa(id)
        var newStr = id2.replace(/==/g, "");
        var finalurl = (this.url + url + '/' + newStr + '?version=' + version)
        window.open(finalurl, "_blank");
    }
    makinglive(version, id) {
        var prod = {
            version: version
        }
        this.blogpostService.Live(prod, id).then(data => {
            if (data.status) {
                this.initdata()
                $(function () {
                    $('#oldblog').modal('toggle');
                });
            }
        })
    }
    openDeactive(i, blog) {
        this.index = i;
        this.isactive = blog.isactive;
        this.bid = blog.blogId;
    }
    DeactiveProduct() {
        var _isactive = 0;
        if (this.isactive == true) {
            _isactive = 0;
        }
        else {
            _isactive = 1;
        }
        var prod = {
            isactive: _isactive
        }
        this.blogpostService.Deactive(prod, this.bid).then(data => {
            if (data) {
                this.initdata()
                $(function () {
                    $('#activedeactive').modal('toggle');
                });
            }
        })
    }
    Requestblog(i, blog) {
        this.index = i;
        this.id = blog.blogId
        this.blogversionid = blog.id
    }
    blogaccpeted() {
        var data = {
            status: "LIVE",
            postid: this.blogversionid
        }
        this.blogpostdetailservice.Updatestatus(data, this.id).then(data => {
            this.blogpreview = data.data
            if (data.data.length > 0) {
                if (data.data[0].status == 'LIVE' && (data.data[0].version == 1.0 || data.data[0].version == 1)) {
                    var blogdata = {
                        blog: data.data[0],
                        id: btoa(data.data[0].blogId)
                    }
                    this.blogpostService.sendmail(blogdata).then(data => {
                    })
                }
            }
            $.notify({
                message: "Blog Accpeted"
            }, {
                type: 'success',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            $(function () {
                $('#Request').modal('toggle');
            });
        })
    }
    blogrejected() {
        var data = {
            status: "REJECTED",
            postid: this.blogversionid
        }
        this.blogpostdetailservice.Updatestatus(data, this.id).then(data => {
            this.blogpreview = data.data
            $.notify({
                message: "Blog Rejected"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            $(function () {
                $('#Request').modal('toggle');
            });
        })
    }

    oldblog(blog) {
        this.title = blog.title
        this.version = blog.version
        var data = {
            title: blog.title,
            version: blog.version
        }
        this.blogpostdetailservice.Oldblog(blog.blogId).then(data => {
            if (data.status) {
                this.blog = data.data
            }
        })
    }
    cancelAction() {
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/blogverify/blogverify.page.ts